import { useEffect, useState } from "react";
import FullScreenPanel from "app/ui/FullScreenPanel";
import useGameState, {
  GameAction,
  useGameActionDispatch,
} from "app/game/useGameState";
import { GODOT_MESSAGE, sendGodotMessage } from "app/godot-embed/godot-bridge";
import cn from "app/util/classnames";

interface SettingsProps {
  onClose: () => void;
}

// Settings menu UI
export default function Settings(props: SettingsProps) {
  const { isAudioMuted, showPlayTime } = useGameState();
  useState(showPlayTime);
  const dispatch = useGameActionDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function handleMuteToggled(e: React.ChangeEvent<HTMLInputElement>) {
    dispatch({
      type: GameAction.AUDIO_MUTE_CHANGED,
      payload: { isMuted: e.target.checked },
    });
    sendGodotMessage(
      GODOT_MESSAGE.SET_AUDIO_MUTE,
      e.target.checked ? "true" : "false",
    );
  }

  function handleGameTimeToggled(e: React.ChangeEvent<HTMLInputElement>) {
    dispatch({
      type: GameAction.SHOW_PLAY_TIME_CHANGED,
      payload: { showPlayTime: e.target.checked },
    });
  }

  return (
    <FullScreenPanel
      heading="Settings"
      headingClassName="px-9 pb-5"
      panelClassName="md:max-w-85 md:max-h-48"
      onClose={props.onClose}
    >
      <ul className="flex flex-col items-center gap-1">
        <Toggle
          label="Mute audio"
          toggled={isAudioMuted ?? true}
          onToggled={handleMuteToggled}
        />
        <Toggle
          label="Show play time"
          toggled={showPlayTime ?? false}
          onToggled={handleGameTimeToggled}
        />
      </ul>
    </FullScreenPanel>
  );
}

interface ToggleProps {
  onToggled: (event: React.ChangeEvent<HTMLInputElement>) => void;
  toggled: boolean;
  label: string;
}

function Toggle(props: ToggleProps) {
  return (
    <div>
      <label className={cn("flex gap-2 items-center justify-between", "w-40")}>
        <span>{props.label}</span>
        <input
          type="checkbox"
          className="sr-only peer"
          checked={props.toggled}
          onChange={(e) => props.onToggled(e)}
        />
        <div // Checkbox BG
          className={cn(
            "w-5.5 h-5.5",
            "flex items-center justify-center",
            "bg-green-mid border rounded-xs shadow-inner",
            "hover:border-green-dark",
            "peer-checked:hover:border-green-darker",
            "peer-checked:bg-green-dark",
            "active:scale-95",
            "transition-all duration-100",
            "cursor-pointer",
          )}
        >
          {props.toggled && (
            <div // Check mark
              className={cn("w-3 h-3", "bg-black rounded-xs")}
            />
          )}
        </div>
      </label>
    </div>
  );
}
